import React from "react";
import { Section } from "../ui/Section";
import { Field } from "../ui/Field";
import { MultiSelectChips } from "../ui/MultiSelectChips";
import styles from "../../styles/evento-form.module.css";

export function StepParticipantes({
    form,
    personas,
    participacionesView,

    // UI state
    busquedaPersona,
    setBusquedaPersona,
    dragPart,
    setDragPart,

    // lookups
    personasById,
    habitacionesById,
    habitacionOptions,

    // accordion
    isPartOpen,
    togglePart,
    isSubOpen,
    toggleSub,
    setOpenParts,

    // actions
    addItem,
    removeItem,
    updateArray,
    moveParticipacion,
}) {
    return (
        <Section
            aside={
                <div className={styles["actions-row"]}>
                    <button
                        className={`${styles.btn} ${styles.primary}`}
                        type="button"
                        onClick={() => {
                            addItem("participaciones", {
                                id: null,
                                personaId: "",
                                habitacionIds: [],
                                actividadIds: [],
                                menuIds: [],
                            });
                            const newIdx = form.participaciones.length;
                            setOpenParts((s) => new Set([...s, newIdx]));
                        }}
                    >
                        + Añadir
                    </button>
                </div>
            }
        >
            {participacionesView.map(({ p, idx }) => {
                const open = isPartOpen(idx);

                const persona = personasById.get(String(p.personaId));
                const habitacion = habitacionesById.get(String(p.habitacionIds?.[0]));
                const resumen = `${habitacion ? "Habitación " + habitacion.nombre : "Sin habitación"}`;

                return (
                    <div
                        key={`part-${idx}`}
                        className={`${styles["item-card"]} ${styles.accordion}${styles.mobileAlways} ${open ? styles.open : ""}`}
                    >
                        <button
                            type="button"
                            className={styles["accordion-header"]}
                            onClick={() => togglePart(idx)}
                            draggable
                            onDragStart={() => setDragPart({ fromIdx: idx })}
                            onDragOver={(e) => e.preventDefault()}
                            onDrop={() => {
                                if (!dragPart) return;
                                moveParticipacion(dragPart.fromIdx, idx);
                                setDragPart(null);
                            }}
                            aria-expanded={open}
                            aria-controls={`part-body-${idx}`}
                            title="Arrastra para cambiar el orden"
                        >
                            <div className={styles["accordion-title"]}>
                                <strong>
                                    {persona ? `${persona.nombre} ${persona.apellidos}` : "Sin persona"}
                                </strong>
                                <span className={styles.muted}> — {resumen}</span>
                            </div>
                            <span className={styles.chevron} aria-hidden>
                                ▾
                            </span>
                        </button>

                        <div id={`part-body-${idx}`} className={styles["accordion-body"]}>
                            <div className={styles["item-row"]}>
                                <div className={styles["grid-1"]}>
                                    <Field label="Cliente" required>
                                        <input
                                            type="text"
                                            placeholder="Buscar persona..."
                                            value={busquedaPersona[idx] || ""}
                                            onChange={(e) => {
                                                const next = [...busquedaPersona];
                                                next[idx] = e.target.value;
                                                setBusquedaPersona(next);
                                            }}
                                            className={styles.searchInput}
                                            style={{ marginBottom: "8px" }}
                                        />

                                        <select
                                            value={p.personaId ?? ""}
                                            onChange={(e) => {
                                                const v = e.target.value;
                                                updateArray("participaciones", idx, "personaId", v ? Number(v) : "");
                                            }}
                                        >
                                            <option value="">Selecciona persona</option>
                                            {personas
                                                .filter((personaIt) => {
                                                    const seleccionadas = form.participaciones
                                                        .filter((_, i2) => i2 !== idx)
                                                        .map((x) => x.personaId);

                                                    if (seleccionadas.includes(personaIt.id)) return false;

                                                    const b = busquedaPersona[idx] || "";
                                                    return (
                                                        personaIt.nombre.toLowerCase().includes(b.toLowerCase()) ||
                                                        personaIt.apellidos.toLowerCase().includes(b.toLowerCase())
                                                    );
                                                })
                                                .map((personaIt) => (
                                                    <option key={personaIt.id} value={personaIt.id}>
                                                        {personaIt.nombre} {personaIt.apellidos}
                                                    </option>
                                                ))}
                                        </select>

                                    </Field>
                                </div>

                                <div className={`${styles["sub-accordion"]} ${styles["grid-cols"]}`}>
                                    <div className={`${styles["sub-acc"]} ${isSubOpen(idx, "opt") ? styles.open : ""}`}>
                                        <button
                                            type="button"
                                            className={styles["sub-acc-head"]}
                                            onClick={() => toggleSub(idx, "opt")}
                                        >
                                            <span>Habitación(es)</span>
                                            <span className={styles["sub-acc-meta"]}>
                                                {p.habitacionIds?.length || 0} seleccionada(s)
                                            </span>
                                            <span className={styles.chevron} aria-hidden>
                                                ▾
                                            </span>
                                        </button>

                                        <div className={styles["sub-acc-body"]}>
                                            <MultiSelectChips
                                                options={habitacionOptions}
                                                value={p.habitacionIds}
                                                onChange={(vals) =>
                                                    updateArray("participaciones", idx, "habitacionIds", vals)
                                                }
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className={styles["item-actions"]}>
                                    <button
                                        className={`${styles.btn} ${styles.danger}`}
                                        type="button"
                                        onClick={() => removeItem("participaciones", idx)}
                                    >
                                        Eliminar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            })}

            <div className={styles.hint}>
                Los menús, vinos y actividades se asignarán más adelante.
            </div>
        </Section>
    );
}
